import { Injectable, inject } from '@angular/core'
import {
  HTTP_INTERCEPTORS,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http'
import type { Observable } from 'rxjs'

import { AuthenticationService } from '@/app/core/services/auth.service'

/** /api/auth/* and /api/health/* are anonymous — see docs/API_SPECIFICATION.md#auth */
const ANONYMOUS_PATH_PATTERN = /\/api\/(auth|health)(\/|$)/

@Injectable()
export class AuthTokenInterceptor implements HttpInterceptor {
  private authService = inject(AuthenticationService)

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const accessToken = this.authService.accessToken

    if (!accessToken || ANONYMOUS_PATH_PATTERN.test(request.url)) {
      return next.handle(request)
    }

    return next.handle(
      request.clone({ setHeaders: { Authorization: `Bearer ${accessToken}` } })
    )
  }
}

export const AuthTokenInterceptorProvider = {
  provide: HTTP_INTERCEPTORS,
  useClass: AuthTokenInterceptor,
  multi: true,
}
